import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  HiOutlineHome,     HiHome,
  HiOutlineArrowUp,  HiArrowUp,
  HiOutlineArrowDown, HiArrowDown,
  HiOutlineUsers,    HiUsers,
  HiOutlineUser,     HiUser,
} from 'react-icons/hi2';

const tabs = [
  { path: '/home',    label: 'Home',    Icon: HiOutlineHome,      ActiveIcon: HiHome },
  { path: '/send',    label: 'Send',    Icon: HiOutlineArrowUp,   ActiveIcon: HiArrowUp },
  { path: '/receive', label: 'Receive', Icon: HiOutlineArrowDown, ActiveIcon: HiArrowDown },
  { path: '/p2p',     label: 'P2P',     Icon: HiOutlineUsers,     ActiveIcon: HiUsers },
  { path: '/profile', label: 'Profile', Icon: HiOutlineUser,      ActiveIcon: HiUser },
];

export default function BottomNav() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav">
      {tabs.map(({ path, label, Icon, ActiveIcon }) => {
        const active = pathname === path;
        const Ic = active ? ActiveIcon : Icon;
        return (
          <button
            key={path}
            className={`nav-item ${active ? 'active' : ''}`}
            onClick={() => navigate(path)}
            aria-label={label}
          >
            <Ic />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
